import useLang from "hooks/useLang";
import { Link } from "react-router-dom";

const ServiceBanner = () => {
  const { lang } = useLang();

  return (
    <div id="service-banner" className="service-banner-section">
      <div className="service-banner-dark">
        <div className="container">
          <div className="content-box">
            <h2>
              {lang.services.our_services.service_banner_our} <span>{lang.services.our_services.service_banner_services}</span>
            </h2>
            <div className="text">{lang.services.our_services.service_banner_detail}</div>
            <Link
              to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20ingin%20mengetahui%20informasi%20lebih%20lanjut%20tentang%20" 
              target="_blank"
              rel="noreferrer"
              className="theme-btn btn-style-one">
              <span className="txt">{lang.services.our_services.service_banner_cta}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceBanner;
